import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useTemplatesData } from '../../hooks';
import { TemplatesDataContextProps } from './types';

export const TemplatesDataContext = ({ customQueryClient, children, ...props }: TemplatesDataContextProps) => {
    const [queryClient] = useState(() => new QueryClient());
    return (
        <QueryClientProvider client={customQueryClient ? customQueryClient : queryClient}>
            <TemplatesDataFetch {...props}>{children}</TemplatesDataFetch>
        </QueryClientProvider>
    );
};

export const TemplatesDataFetch = ({
    children,
    autoFetchTemplates = true,
    autoFetchSellerDocuments = true,
    withInactiveTemplates = false,
    withTemplatesUsage = true,
    ...props
}: Omit<TemplatesDataContextProps, 'customQueryClient'>) => {
    useTemplatesData({
        autoFetchSellerDocuments,
        autoFetchTemplates,
        withInactiveTemplates,
        withTemplatesUsage,
        ...props,
    });
    return <>{children}</>;
};
